import {
  EDITOR_UPDATE_PAGE_BEGIN,
  EDITOR_UPDATE_PAGE_DISMISS_ERROR,
  EDITOR_UPDATE_PAGE_FAILURE,
  EDITOR_UPDATE_PAGE_SUCCESS,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getCookie, updateUserIpInCookie } from '../../home/app_util';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updatePage(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EDITOR_UPDATE_PAGE_BEGIN,
    });
    const { projectId, version, pageId, data } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${pageId}`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_UPDATE_PAGE_SUCCESS,
            data: res.data,
          });
          const { name, uuid } = res.data;
          Mixpanel.track('Updated page on builder', { name, uuid });
          toast.success('Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_UPDATE_PAGE_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update page on builder');
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Updation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdatePageError() {
  return {
    type: EDITOR_UPDATE_PAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_UPDATE_PAGE_BEGIN:
      return {
        ...state,
        updatePagePending: true,
        updatePageError: null,
      };

    case EDITOR_UPDATE_PAGE_SUCCESS:
      let pages = state.pages;
      let index = pages.findIndex(function (page, i) {
        return page.uuid === action.data.uuid;
      });
      pages[index] = action.data;
      return {
        ...state,
        updatePagePending: false,
        updatePageError: null,
        pages: pages,
        selectedPage: action.data,
      };

    case EDITOR_UPDATE_PAGE_FAILURE:
      return {
        ...state,
        updatePagePending: false,
        updatePageError: action.data.error,
      };

    case EDITOR_UPDATE_PAGE_DISMISS_ERROR:
      return {
        ...state,
        updatePageError: null,
      };

    default:
      return state;
  }
}
